import { RequestDocBtn } from '@components/ui/btn/RequestDocBtn'
import { TrialSessionLink } from '@components/ui/link/TrialSessionLink'
import { Business } from '@type/buzzkuri/common'
import { ProgramThumbnailGroup } from '@type/buzzkuri/program-detail'
import { PdfDownload } from './PdfDownload'
import { ProductEffect } from './ProductEffect'
import { ProgramRequestOffer } from './ProgramRequestOffer'
import { RecommendTrainingProgram } from './RecommendTrainingProgram'

type Props = {
  business: Business
  recommendPrograms: ProgramThumbnailGroup
  requiredTime: number
  venue: string
  programId: number
  programName: string
}

export const ProgramDetailsPageSubColumn = ({
  business,
  recommendPrograms,
  requiredTime,
  venue,
  programId,
  programName,
}: Props): JSX.Element => {
  const { id } = business

  return (
    <div className="flex flex-col">
      <div className="flex justify-end md:mt-[6.8vw]">
        <ProductEffect />
      </div>
      {business?.eventRequestable ? (
        <>
          <div className="md:mt-[2.3vw]">
            <ProgramRequestOffer {...{ requiredTime, venue, id, programId }} />
          </div>
          <div className="md:mt-[2.3vw] md:mb-[1vw]">
            <PdfDownload {...{ programId, programName }} />
          </div>
        </>
      ) : (
        <>
          <div className="mt-[2.3vw]">
            <RequestDocBtn referer="プログラム詳細ページサイドカラム" />
          </div>
          {/*sp 開催までの流れ */}
          <div className="mt-[3.1vw]">
            <TrialSessionLink referer="プログラム詳細ページサイドカラム" />
          </div>
        </>
      )}
      <div className="md:mt-[2.3vw]">
        <RecommendTrainingProgram
          {...{ recommendPrograms }}
          heading="おすすめ研修プログラム"
        />
      </div>
    </div>
  )
}
